export default __webpack_public_path__ + "static/media/graph.094573b1.svg";